import script from "./InteriorSectionV2.vue?vue&type=script&setup=true&lang=js"
export * from "./InteriorSectionV2.vue?vue&type=script&setup=true&lang=js"

import "./InteriorSectionV2.vue?vue&type=style&index=0&id=85772276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85772276"]])

export default __exports__